<ng-container *transloco="let convert;">
  <div class="edit-posting-form">
    <h3 class="content-card-title">{{convert('sellModule.posting.exteriorForm.textExterior')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.exteriorForm.textReviewOption')}}</div>

    <form class="body" name="exteriorForm" [formGroup]="exteriorForm" nonvalidate (keydown.enter)="$event.preventDefault()">
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="control-wrapper form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input excludes__input" id="showAllOptions"
                [attr.aria-label]="convert('sellModule.posting.exteriorForm.ariaLabelShowAllOption')" data-track-name="Show All Options"
                data-track-elem="check box"
                [checked]="showAllOptions" (change)="toggleAllOptions()"/>
              <label class="custom-control-label excludes__label" for="showAllOptions">{{convert('sellModule.posting.exteriorForm.ariaLabelShowAllOption')}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-3">
          <div class="form-group">
            <label for="wheels">{{convert('sellModule.posting.exteriorForm.textWheels')}}</label>
            <div class="select-wrapper">
              <select formControlName="wheels" id="wheels" class="custom-select wrapText"
                (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.exteriorForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.exteriorForm.textSelect')}}</option>
                @for (vtOption of vehicleWheelDisplayOption; track vtOption) {
                  <option [ngValue]="vtOption">
                    {{vtOption.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="roof">{{convert('sellModule.posting.exteriorForm.textRoof')}}</label>
            <div class="select-wrapper">
              <select formControlName="roof" id="roof" class="custom-select wrapText"
                (change)="trackFormChanges()">
                <option disabled>{{convert('sellModule.posting.exteriorForm.textAftermarketOption')}}</option>
                <option [ngValue]="'default'">{{convert('sellModule.posting.exteriorForm.textSelect')}}</option>
                @for (vtOption of vehicleRoofDisplayOption; track vtOption) {
                  <option [ngValue]="vtOption">
                    {{vtOption.platformCustomDescription}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <app-options-and-accessories-form [otherOptions]="otherOptions" (onUpdateInstalledOptions)="installOptions($event)" (onRemoveOptionUpdateAvailableOptions)="removeOption($event)">
      </app-options-and-accessories-form>
    </form>
  </div>
</ng-container>
